export default __webpack_public_path__ + "static/media/cooey_hero.39e3ac27.png";